export const titleCase = (str) => {

    str = str.toLowerCase().split(' ');

    for (var i = 0; i < str.length; i++) {

      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 

    }

    return str.join(' ');

};

export const formatPrice = (price, attributes, field = "price", currency = "KES") => {
  if (price === "Varies" && attributes?.length > 0) {
      // Extract numeric values from the specified field
      const numericPrices = attributes
          .map(attr => parseFloat(attr[field]))
          .filter(p => !isNaN(p));

      if (numericPrices.length > 0) {
          const minPrice = Math.min(...numericPrices);
          const maxPrice = Math.max(...numericPrices);

          return `${currency} ${minPrice.toLocaleString('en-KE')} - ${maxPrice.toLocaleString('en-KE')}`;
      } else {
          return "Varies";
      }
  } else {
      const numericPrice = parseFloat(price);
      if (!isNaN(numericPrice)) {
          return `${currency} ${numericPrice.toLocaleString('en-KE')}`;
      } else {
          return `${currency} ${price}`;
      }
  }
};

export const renderMoqAttributes = (moqAttributes) => {
  if (!Array.isArray(moqAttributes) || moqAttributes.length === 0) return null;

  return moqAttributes.map((attr, idx) => {
    let actualShippingFee = null;
    let readableSize = null;

    if (attr.readable_size) {
      readableSize = (
        <div key={`size-${idx}`}>
          <strong><u>Size/Pattern: {attr.readable_size}</u></strong>
        </div>
      );
    }

    if (attr.actual_shipping_fee_air) {
      actualShippingFee = (
        <div key={`air-${idx}`}>Actual Shipping Fee (Air): {attr.actual_shipping_fee_air}</div>
      );
    } else if (attr.actual_shipping_fee_sea) {
      actualShippingFee = (
        <div key={`sea-${idx}`}>Final Shipping Fee (Sea): KES. {attr.actual_shipping_fee_sea}</div>
      );
    } else {
      actualShippingFee = (
        <div key={`na-${idx}`}>Final Shipping Fee: N/A</div>
      );
    }

    return (
      <div key={idx} style={{ marginBottom: '0.5em', paddingLeft: '1em' }}>
        {readableSize}
        <div>Approx. Shipping Fee Air: KES. {attr.shipping_fee_air ?? 'N/A'}</div>
        <div>Approx. Shipping Fee Sea: KES. {attr.shipping_fee_sea ?? 'N/A'}</div>
        {actualShippingFee}
      </div>
    );
  });
}